import React from 'react';
import Section from "../homepage/section"
import FoxNotFound from "../../resources/fox_not_found.png"
import FoxExpired from "../../resources/fox_expired.png"
import FoxProgress from "../../resources/fox_progress.png"

import ctrans from "../../common/trans"
import {getAuditId} from "../../common/helpers"
import history from "../../common/history"
import {
    css,
    Header,
    Button,
    Div,
} from "@bdfx/fukit"

interface Props {
    code: number | null
}

const ErrorPage = ({code}: Props) => <Style>
    <div>
        <Div textAlign="right" paddingTop="150px" minHeight={"350px"}>
            <Header type={"h1"}>{code === 400 ? ctrans("audit_is_in_progress") : code === 403 ? ctrans("audit_expired") : ctrans("audit_not_found")}</Header>
            {code === 403 ? <>
                <img src={FoxExpired} alt={ctrans("audit_expired")} />
                <p>
                    {ctrans("audit_expired_info")}
                </p>
                <Button color="green" size="tiny" icon="repeat" secondary={true} onClick={() => {window.location.href = `/audit/${getAuditId()}/regenerate`}}>{ctrans("regenerate")}</Button>

            </>
            : 
            code === 400 ? <>
                <img src={FoxProgress} alt={ctrans("audit_is_in_progress")} />
                <p>
                    {ctrans("audit_is_in_progress_info")}
                </p>
                <Button color="green" size="tiny" icon="repeat" secondary={true} onClick={() => window.location.reload()}>{ctrans("refresh")}</Button>

            </>
            : 
            <>
                <img src={FoxNotFound} alt={ctrans("audit_not_found")} />
                <p>
                    {ctrans("audit_not_found_info")}
                </p>
                <Button color="green" size="tiny" icon="plus-light" secondary={true} onClick={() => history.push('/')}>{ctrans("create_new_audit")}</Button>

            </>}
        </Div>
    </div>
</Style>

const Style = css(Section)({
    "img": {
        float: "right",
        marginTop: "-50px",
    },
    "p": {
        textAlign: "right",
        fontSize: "1.5rem",
    }
})

export default ErrorPage